import * as React from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { X } from 'lucide-react'

type IconButtonProps = React.ComponentProps<typeof Button> & {
  iconColor?: string
  iconSize?: number
}

export const IconCloseButton: React.FC<IconButtonProps> = ({
  iconColor = 'currentColor',
  iconSize = 18,
  className,
  type = 'button',
  ...props
}) => {
  return (
    <Button
      type={type}
      variant='ghost'
      size='icon'
      aria-label={props['aria-label'] ?? 'Close'}
      className={cn('size-6 rounded-md p-0 shadow-none', className)}
      {...props}
    >
      <X style={{ color: iconColor, width: iconSize, height: iconSize }} />
    </Button>
  )
}
